/* eslint-disable react/prefer-es6-class */
import classNames from 'classnames';
import React from 'react';
import Localization from 'es6/services/localization';

export default React.createClass({
  displayName: 'HintButton',

  propTypes: {
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    hints: React.PropTypes.number,
    maxHints: React.PropTypes.number,
    onClick: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      className: '',
      disabled: false,
      hints: 0,
      maxHints: 1,
    };
  },

  render() {
    const { disabled, hints, maxHints, onClick } = this.props;
    const className = classNames('btn btn-bar btn-default hint-button', {
      disabled: hints >= maxHints || disabled,
    }, this.props.className);

    return (
      <button className={className} onClick={onClick}>
        {Localization.t('show-hint')} <div className="remaining">{maxHints - hints}</div>
      </button>
    );
  },
});
